import { render, staticRenderFns } from "./screeningJB.vue?vue&type=template&id=7813bfc1&scoped=true&"
import script from "./screeningJB.vue?vue&type=script&lang=js&"
export * from "./screeningJB.vue?vue&type=script&lang=js&"
import style0 from "./screeningJB.vue?vue&type=style&index=0&id=7813bfc1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7813bfc1",
  null
  
)

export default component.exports